"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublicChannel = void 0;
var channel_1 = require("../../../private/services/channel/channel");
var PublicChannel = /** @class */ (function () {
    function PublicChannel(httpClient, baseUrl) {
        this.baseUrl = baseUrl;
        this.privateService = new channel_1.PrivateChannel(httpClient, baseUrl);
    }
    /**
     * Returns a list of purchases made by currently active user
     * @param {string} channelId
     * @param {string} instance
     * @param {ChannelRequestOptions} requestConfig
     * @returns {Promise<HttpResponse<MemberInfoResponse>>}
     */
    PublicChannel.prototype.getMemberInfo = function (channelId, instance, requestConfig) {
        return this.privateService.getPublicMemberInfo(channelId, instance, requestConfig);
    };
    PublicChannel.prototype.getVideoPreviewUrls = function (channelId, instance, requestConfig) {
        return this.privateService.getPublicVideoPreviewUrls(channelId, instance, requestConfig);
    };
    /**
     * Returns channel response (similar to PrivateChannel entity)
     * @param channelId
     * @param extraOptions
     * @param requestConfig
     * @return Promise<HttpResponse<PublicChannelItem>>
     */
    PublicChannel.prototype.getInfo = function (channelId, extraOptions, requestConfig) {
        return this.privateService.getPublicInfo(channelId, extraOptions, requestConfig);
    };
    /**
     * Fetch YT channel by VOD's channel
     * @param channel
     */
    PublicChannel.prototype.getExternalChannelInfo = function (channel) {
        return this.privateService.fetchExternalSingleItem(channel);
    };
    return PublicChannel;
}());
exports.PublicChannel = PublicChannel;
//# sourceMappingURL=channel.js.map